/* Log Release 2022-06-15 15:09 */
$(function() {
    const mainSlider = $('.main-slider')
    if (mainSlider.length > 0) {
        new Swiper(".main-slider", {
            loop: $('.main-slider .slide').length > 1,
            autoplay: {
                delay: 3500,
                disableOnInteraction: false
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true
            }
        });
    }

    activeMenu();

    const mustHaveSlider = $('.must-have__collection__carousel')
    if (mustHaveSlider.length > 0) {
        new Swiper(".must-have__collection__carousel", {
            pagination: {
                el: ".swiper-pagination",
                clickable: true
            },
        });
    }

    const announcementSlider = $('.announcement-bar__carousel')
    if (announcementSlider.length > 0) {
        new Swiper(".announcement-bar__carousel", {
            initialSlide: 1,
            loop: true,
            autoplay: {
                delay: 3000,
                disableOnInteraction: true
            }
        });
    }
     new Swiper('.feature-swiper', {
            slidesPerView: 'auto',
            a11y: false,
            updateOnWindowResize: true,
            grabCursor: true,
             spaceBetween: 25,
             centeredSlides: true,
            centeredSlidesBounds: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },

            breakpoints: {
                1024: {
                    slidesPerView: 4,
                    grabCursor: false,
                    allowTouchMove: false

                }
            }
        })

    const collectionSwiperWrapper = $('.featured-collection');

    if (collectionSwiperWrapper.find('.collection-swiper').length > 0) {
        new Swiper('.collection-swiper:not([data-swiper-activation="false"])', {
            slidesPerView: 2,
            spaceBetween: 25,
            a11y: false,

            scrollbar: {
                el: ".swiper-scrollbar",
                hide: false,
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            breakpoints: {
                1024: {
                    slidesPerView: 4
                }
            }
        });

        collectionSwiperWrapper.each(function(i) {
            const collectionSwiper = $(this).find('.collection-swiper');
            collectionSwiper.each(function(i) {
                if (i > 0) $(this).hide();
            });
        });

        // if (collectionSwiper.length > 1) {
        //     collectionSwiper.each(function(i) {
        //         if (i > 0) $(this).hide();
        //     })
        // }

        const collectionTitle = $('.featured-collection__title')
        const activeClass = 'featured-collection__title--active'
        if (collectionTitle.length > 0 && collectionTitle.length > 1) {
            collectionTitle.click(function() {
                const collection = $(this).data('collection')
                const collectionSel = $('[data-collection="'+collection+'"]')
                if (collectionSel.is(':hidden')) {
                    const swiperCollection = $('.collection-swiper')
                    collectionTitle.removeClass(activeClass)
                    $(this).addClass(activeClass)
                    swiperCollection.hide()
                    collectionSel.show()
                }
            })
        }
    }



    $('.mm-trigger').on('click', function() {
        $('body').addClass('mobile-menu-active')
    });

    $('.close-menu').on('click', function() {
        $('body').removeClass('mobile-menu-active')
        setTimeout(function() {
            let firstClass = 'first-level'
            let secondCLass = 'second-level'
            let activeClass = 'active'
            $('.header-menu').removeClass(secondCLass)
            $('.header-menu').removeClass(firstClass)
            $('.header-menu .first-level').text('Menu')
            $('.menu-mobile-item.has-dropdown').removeClass(activeClass)
        }, 200)
    });

    $('.menu-mobile-item.has-dropdown > .menu-mobile-link').on('click', function(e) {
        e.preventDefault()
        $(this).parent().toggleClass('active')
        let menuItem = $(this).data('item')
        $('.header-menu').addClass('first-level')
        if ($(this).hasClass('first-level')) {
            $('.header-menu .first-level').text(menuItem)
        } else if ($(this).hasClass('second-level')) {
            $('.header-menu .second-level').text(menuItem)
            $('.header-menu').addClass('second-level')
        }
    });

    $('.back').on('click', function() {
        let firstClass = 'first-level'
        let secondCLass = 'second-level'
        let activeClass = 'active'

        if ($('.header-menu').hasClass(firstClass) && !$('.header-menu').hasClass(secondCLass)) {
            $('.header-menu .first-level').text('Menu')
            $('.header-menu').removeClass(firstClass)
            $('.menu-mobile-item.has-dropdown.active').removeClass(activeClass)
        }

        if ($('.header-menu').hasClass(secondCLass)) {
            $('.header-menu').removeClass(secondCLass)
            $('.menu-mobile-item.has-dropdown.active .menu-mobile-item.has-dropdown.active').removeClass(activeClass)
        }
    });

    const sizeGuide = $('#size-guide')
    if (sizeGuide.length > 0) WAU.Modal.init("size-guide");

    const measuringGuide = $('#measuring-guide')
    if (measuringGuide.length > 0) WAU.Modal.init("measuring-guide");


    /* Custom Desktop Search */
    const inputSearchR = document.querySelector('.searchbox__input'),
        inputSearchF = document.querySelector('input[name="q"]');

    if(inputSearchR && inputSearchF) {
        inputSearchF.addEventListener('keyup', theme.Helpers.debounce(event => {
            /*
                // Show Panel
                if(!document.querySelector('#slideout-search-sidebar').classList.contains('slideout--active')) _cSc(document.querySelector('.slideout__trigger-search'));
                inputSearchR.value = inputSearchF.value;
                inputSearchR.dispatchEvent(new Event('input'));
                //inputSearch.dispatchEvent(new Event('input', {bubbles:true}));
            */
            if(event.keyCode === 27) return;
            triggerDesktopSearch(inputSearchF,inputSearchR);
        }, 300));
    }

    if(inputSearchR && inputSearchF) {
        inputSearchF.addEventListener('focus', event => {
            event.currentTarget.className = event.currentTarget.value ? 'rounded-input__input rounded-input__input--hv' : 'rounded-input__input';
            if(event.currentTarget.value) triggerDesktopSearch(inputSearchF,inputSearchR);
        });
    }

    if(inputSearchR && inputSearchF) {
        inputSearchF.addEventListener('blur', event => {
            event.currentTarget.className = event.currentTarget.value ? 'rounded-input__input rounded-input__input--hv' : 'rounded-input__input';
        });
    }
    /* Custom Desktop Search */

    /* Custom Sort By */
    if(document.querySelector('.sort-item-link')) {

        // append query vars onto sort urls (e.g. filters, vendor collection)
        if (location.href.indexOf('?') >= 0) {
            $('.sort-item-link .link-dropdown__link').each(function () {
                var queryTerms = location.href.split('?')[1].split('&');
                var newHref = $(this).attr('href');
                queryTerms.forEach(function (term) {
                    if (term.indexOf('sort_by=') === -1) {
                        newHref += '&' + term;
                    }
                });
                $(this).attr('href', newHref);
            });
        }

        // document.querySelector('.collection__filtering')
    }
    /* Custom Sort By */

    if (document.body.classList.contains('product') == true) {
        var btnIconMail = jQuery("<span class='fa'><svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path d='M15.3 2.2a.68.68 0 0 1 .7.7v10.2a.68.68 0 0 1-.7.7H.7a.68.68 0 0 1-.7-.7V2.9a.68.68 0 0 1 .7-.7h14.6zm-.8 1.4h-13v8.7h13.1V3.6zm-1.2 1.1c.2.3.2.7-.1 1l-.1.1-4.7 3.5c-.2.2-.5.2-.7 0h-.1L2.8 5.7c-.3-.3-.3-.7-.1-1s.6-.4.9-.2h.1L8 7.8l4.4-3.3c.3-.2.7-.2.9.2z' fill='#000000'/></svg></span>")
        if(jQuery('#backinstockWrapper .osf_inline_button').length > 0) {
            jQuery('#backinstockWrapper .osf_inline_button').append(jQuery(btnIconMail));
        }

        jQuery('.swatches__form--label').on('click', function() {
            if(jQuery('#backinstockWrapper .osf_inline_button').length > 0) {
                jQuery('#backinstockWrapper .osf_inline_button').append(jQuery(btnIconMail));
            } else {
                return;
            }
        });
    }

    // fixLinkPages();
    window.addEventListener('scroll', ZendScrollHandler, false);

    // Fix Search
    document.querySelector('#searchbox').addEventListener('submit', event => {
        event.preventDefault();
        if(document.querySelector('#predictiveSearchForm input[type="text"]') && document.querySelector('#predictiveSearchForm input[type="text"]').value) document.querySelector('#predictiveSearchForm').submit();
    });

    let myTimeout = false
    document.addEventListener('DOMSubtreeModified', () => {
        if (myTimeout) clearTimeout(myTimeout);
        myTimeout = setTimeout(removeSizeFromTitle(), 1000);
    })
    function removeSizeFromTitle() {
        const dfdRoot = document.querySelector('.dfd-root')
        if (dfdRoot && dfdRoot.classList.contains('phx-connected')) {
            const cardTitles = document.querySelectorAll('.dfd-card-title')
            if (cardTitles.length > 0) {
                cardTitles.forEach(e => {
                    if (e) {
                        const regExp = /\(([^)]+)\)/
                        const titleWNumber = e.innerHTML.trim()
                        const sizeDelete = regExp.exec(titleWNumber)
                        if (sizeDelete) e.innerHTML = titleWNumber.replace(sizeDelete[0], '')
                    }
                    myTimeout = false
                })
            }
        }
    }
});

function ZendScrollHandler() {
    const zendWidget = document.querySelector('#launcher');
    if(!zendWidget) return;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    zendWidget.style.display = scrollTop > 150 ? 'block' : 'none';
}

function triggerDesktopSearch(searchF,searchR) {
    // Show Panel
    if(!document.querySelector('#slideout-search-sidebar').classList.contains('slideout--active')) _cSc(document.querySelector('.slideout__trigger-search'));
    searchR.value = searchF.value;
    searchR.dispatchEvent(new Event('input'));
    if(!searchF.value) _cSc(document.querySelector('#slideout-search-sidebar .slideout__trigger-search-sidebar'));
    //inputSearch.dispatchEvent(new Event('input', {bubbles:true}));
}

function customStickyEventsToolbar() {
    var observer = new IntersectionObserver(function(entries) {
        if(entries[0].intersectionRatio === 0)
            document.body.classList.add('filter-toolbar-shadow');
        else if(entries[0].intersectionRatio === 1)
            document.body.classList.remove('filter-toolbar-shadow');
    }, { threshold: [0,1] });

    observer.observe(document.querySelector('.colleciton__page-title--listener'));
}

/* Custom Accordion: Footer - Cart - Product Info Tabs -------------------------------------------------------------------- */
window.addEventListener('DOMContentLoaded', mobileAccordion);

function mobileAccordion() {
    const els = [...document.querySelectorAll('.open-toggle > .column-title')];
    els.forEach(el => {
        el.addEventListener('click', handleCustomAccorion)
        if(el.nextElementSibling.matches('.active')) el.nextElementSibling.style.height = `${el.nextElementSibling.offsetHeight}px`;
    });
}

function handleCustomAccorion(e) {
    e.preventDefault();
    const nEl = e.currentTarget.nextElementSibling;
    if(!nEl.classList.contains('active')) {
        const p = e.currentTarget.closest('.columns-wrapper');
        const tEl = p.querySelector('.open-toggle.active');
        if(tEl) {
            const tnEl = tEl.querySelector('.no-bullet.active');
            closeCustomAccordion(tEl,tnEl);
        }
        e.currentTarget.closest('.open-toggle').classList.toggle('active');
        nEl.classList.toggle('active');
        nEl.style.height = 'auto';
        const _h = nEl.clientHeight + 'px';
        nEl.style.height = '0px';
        setTimeout(function () {
            nEl.style.height = _h;
        }, 0);
    } else {
        closeCustomAccordion(e.currentTarget,nEl);
    }
}

function closeCustomAccordion(triggerEl,listEl) {
    triggerEl.closest('.open-toggle').classList.toggle('active');
    listEl.style.height = '0px';
    listEl.addEventListener('transitionend', function () {
        listEl.classList.remove('active');
    }, {
        once: true
    });
}
/* Custom Accordion: Footer - Cart - Product Info Tabs -------------------------------------------------------------------- */

/* Trigger Click */
function _cSc(el) {
    if(!el) return;
    var evt = new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window
        }),
        canceled = !el.dispatchEvent(evt);
}
/* Trigger Click */

/* Manage active state */
function activeMenu() {
    if(!current_location_pathname) return;
    if(current_location_pathname.indexOf('/blogs/news-and-events') > -1 && document.body.matches('.template-article')) {
        addActiveClassMenu('/blogs/news-and-events');
        return;
    }
    addActiveClassMenu(null);
}

function addActiveClassMenu(newVal) {
    if(newVal) current_location_pathname = newVal;
    document.querySelectorAll('#main-nav li:not(.view-all) a').forEach(a => {
        const h = a.getAttribute('href');
        if(h === current_location_pathname) {
            // console.log("MATCH: "+h+" vs. "+current_location_pathname);
            // debugger;
            if(a.parentElement.classList.contains('view-all')) return false;
            a.classList.add('is-current','is-active');
            if(a.parentElement.classList.contains('navigation__menuitem')) a.parentElement.classList.add('is-current-parent','is-active');
            // a.dataset.active = 'true';
            const rd = a.closest('.megamenu__list'),
                nd = a.closest('.megamenu');
            if(rd){
                // debugger;
                rd.closest('.megamenu__list').previousElementSibling.classList.add('is-current-parent','is-active');
                rd.closest('.navigation__menuitem').classList.add('is-current-parent','is-active');
            } else if(nd){
                nd.closest('.navigation__menuitem').classList.add('is-current-parent','is-active');
            }
            return false;
        }
    });
}
/* Manage active state */

window.addEventListener('DOMContentLoaded', function() {
    var challengeContainer = document.querySelector('.shopify-challenge__container');
    if (challengeContainer) {
        var submitInput = document.querySelector('input[type="submit"]');
        if (submitInput) {
            var button = document.createElement('button');

            button.type = 'submit';
            button.innerHTML = submitInput.value;
            button.className = submitInput.className + ' button btn-secondary';

            button.setAttribute('data-title', submitInput.value);

            var inputElement = document.querySelector('input[type="submit"]');

            inputElement.value = "";

            submitInput.parentNode.replaceChild(button, submitInput);
        }
    }
});


/* Controlling Measmerize Tracking */
window.addEventListener('DOMContentLoaded', function () {

    function getCookie(name) {
        let value = `; ${document.cookie}`;
        let parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    }

    function checkCookieConsent() {
        const consentCookie = getCookie('CookieConsent');
        if (consentCookie) {
            try {
                const consentData = decodeURIComponent(consentCookie);
                if (consentData.includes('preferences:true') &&
                    consentData.includes('statistics:true') &&
                    consentData.includes('marketing:true')) {
                    return true; // Cookie accettati
                }
            } catch (error) {
                console.error('Errore durante la verifica del consenso dei cookie:', error);
            }
        }
        return false;
    }

    function waitForMeasmerize() {
        if (window.measmerize && window.measmerize.tracking) {
            if (checkCookieConsent()) {
                window.measmerize.tracking.enableAnalytics();

                document.querySelector('#addToCart').addEventListener('click', function() {
                    window.measmerize.tracking.send.addToBasket();
                });

                document.querySelector('#measmerize-button').addEventListener('click', function() {
                    window.measmerize.tracking.send.openSizeGuide();
                });
            } else {
                window.measmerize.tracking.disableAnalytics();
            }

        } else {
            setTimeout(waitForMeasmerize, 500);
        }
    }

    waitForMeasmerize();
});

